import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PrivacyPolicyPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section - Mismo estilo que Home */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">

          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            Privacy Policy
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            Your Privacy Matters to Us
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Last Updated: {new Date().getFullYear()}
          </p>
        </div>
      </section>

      {/* Privacy Highlights */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">S</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Secure Data</h3>
              <p className="text-gray-600">
                Your personal information is encrypted and securely stored.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">C</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Your Control</h3>
              <p className="text-gray-600">
                You can access, update, or delete your data at any time.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">X</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">No Sharing</h3>
              <p className="text-gray-600">
                We never sell your personal information to third parties.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Policy Details */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-8">
              Our Privacy Policy Details
            </h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">1.</span>
                  Information We Collect
                </h3>
                <div className="bg-gray-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    We collect information that you provide directly to us, including:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Account Information:</strong> Name, email address, password (encrypted), and contact details</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Purchase Information:</strong> Payment details (processed securely through third-party payment processors), order history, and billing address</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Usage Data:</strong> Information about how you interact with our website, products, and services</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Communication Data:</strong> Messages, feedback, and support requests you send to us</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">2.</span>
                  How We Use Your Information
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    We use the information we collect to:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Process and fulfill your orders and provide customer support</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Send you important updates about your account, orders, and our services</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Improve our website, products, and user experience</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Send you marketing communications (only with your consent)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Detect and prevent fraud, abuse, and security issues</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">3.</span>
                  Information Sharing
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    We do not sell your personal information. We may share your information only in the following circumstances:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Service Providers:</strong> With trusted third-party service providers who help us operate our business (payment processors, email services, hosting providers)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Legal Requirements:</strong> When required by law, court order, or government regulation</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets (with notice to users)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>With Your Consent:</strong> When you explicitly authorize us to share your information</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">4.</span>
                  Cookies and Tracking Technologies
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    We use cookies and similar tracking technologies to:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Remember your preferences and settings</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Analyze website traffic and usage patterns</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Provide personalized content and advertisements</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Improve our services and user experience</span>
                    </li>
                  </ul>
                  <p className="text-gray-700 mt-4">
                    You can control cookies through your browser settings. However, disabling cookies may limit some website functionality.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">5.</span>
                  Your Rights and Choices
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    You have the following rights regarding your personal information:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Access:</strong> Request a copy of the personal information we hold about you</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Correction:</strong> Request correction of inaccurate or incomplete information</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Deletion:</strong> Request deletion of your personal information (subject to legal requirements)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span><strong>Data Portability:</strong> Request your data in a portable format</span>
                    </li>
                  </ul>
                  <p className="text-gray-700 mt-4">
                    To exercise these rights, please contact us at <a href="mailto:privacy@espanolhub.com" className="text-primary-600 hover:underline">privacy@espanolhub.com</a>
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">6.</span>
                  International Data Transfers
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    Your information may be transferred to and processed in countries other than your country of residence. 
                    These countries may have data protection laws that differ from those in your country. We take appropriate 
                    measures to ensure your information is protected in accordance with this Privacy Policy regardless of where it is processed.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">7.</span>
                  Children's Privacy
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    Our services are not directed to children under the age of 13. We do not knowingly collect personal 
                    information from children under 13. If you believe we have collected information from a child under 13, 
                    please contact us immediately, and we will take steps to delete such information.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">8.</span>
                  Changes to This Policy
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    We may update this Privacy Policy from time to time. We will notify you of any material changes by 
                    posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to 
                    review this Privacy Policy periodically to stay informed about how we protect your information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact for Privacy */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-5xl mb-6">Contact</div>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            Questions About Privacy?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            If you have any questions or concerns about our Privacy Policy or how we handle your data, please contact us.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition transform hover:scale-105 shadow-lg"
            >
              Contact Support
            </Link>
          </div>
          <p className="text-sm text-gray-500 mt-4">
            Average response time: Under 24 hours
          </p>
        </div>
      </section>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
